<div class="addition-charge-area" style="width: 75vw;justify-content: space-between;">
  <div class="agreement-area form-container" style="margin-right: 10px;">
    <div class="title">Additional Charges</div>
    <div  class="title-section" ><div *ngIf="operation !=='view'"  (click)="onAddCostItem('charge')"><mat-icon style="position: relative; top: 7px;cursor: pointer;" class="code">add</mat-icon><span class="code add-item">Add cost Item</span></div></div>
    <table style="border: 1.5px solid #ccc;margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="chargesList" [ngClass]="operation!=='view'?'enable-field':'disable-field'" >
     
      <tr class="accord-area">
        @for (i of chargesColumn; track $index) {
        @if (i === 'delete') {
        <ng-container matColumnDef={{i}}>
          <th mat-header-cell *matHeaderCellDef style="width: 3%;">
          </th>
          <td mat-cell *matCellDef="let element; let ind=index">
            <div style="display: inline-flex;box-sizing: content-box">
              <mat-icon style="font-size: 21px;color:#D40511;cursor: pointer;" (click)="onChargeDelete(ind)">delete</mat-icon>
            </div>
          </td>
        </ng-container>
        }
        @else if(i === "charge"){
        <ng-container matColumnDef={{i}}>
          <th mat-header-cell class="scrollable" *matHeaderCellDef>
            <div>Additional Charge</div>
          </th>
          <td class="scrollable" mat-cell *matCellDef="let element; let ind=index">
            <div>
              <input type="text" maxlength="256" value={{element[i]}} (change)="onAdditionVal($event.target,ind, 'charge')">
            </div>
          </td>
        </ng-container>
        }
        @else{
          <ng-container matColumnDef={{i}}>
            <th mat-header-cell class="scrollable" *matHeaderCellDef >
              <div>Rate</div>
            </th>
            <td class="scrollable" mat-cell *matCellDef="let element; let ind=index">
              <div>
                <input type="number" value={{formatElementData(element[i])}} style="width: 100px;" (change)="onAdditionVal($event.target,ind,'rate')">
              </div>
            </td>
          </ng-container>
        }
        }
      </tr>
      <tr mat-header-row *matHeaderRowDef="chargesColumn"></tr>
      <tr mat-row *matRowDef="let row; columns: chargesColumn;"></tr>

    </table>
  </div>

  <div class="maunt-area form-container" style="margin-left: 10px;">
    <div class="title">Maut</div>
    <div  class="title-section"  ><div *ngIf="operation !=='view'" (click)="onAddCostItem('maunt')"><mat-icon style="position: relative; top: 7px;cursor: pointer;" class="code">add</mat-icon><span class="code add-item">Add cost Item</span> </div></div>
    <table style="border: 1.5px solid #ccc;margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="mauntList" [ngClass]="operation!=='view'?'enable-field':'disable-field'" >

      <tr class="accord-area">
        @for (i of mountColumn; track $index) {
        @if (i === 'delete') {
        <ng-container matColumnDef={{i}}>
          <th mat-header-cell *matHeaderCellDef style="width: 3%;">
          </th>
          <td mat-cell *matCellDef="let element; let ind=index">
            <div style="display: inline-flex;box-sizing: content-box">
              <mat-icon class="code" style="cursor: pointer;" (click)="onMautDelete(ind)">delete</mat-icon>
            </div>
          </td>
        </ng-container>
        }
        @else if(i === "country"){
        <ng-container matColumnDef={{i}}>
          <th mat-header-cell class="scrollable" *matHeaderCellDef>Country</th>
          <td class="scrollable" mat-cell *matCellDef="let element;let ind=Index">
              <select required (change)="checkOnCountryList($event.target,element)" style="width:200px;     border: 1px solid #ccc;font-weight: 500; font-size: 14px;">
                <option *ngIf="element['country']===0">Choose</option>
                <option *ngFor="let option of countryListArr" [value]="option.CountryID" [selected]="(element['country'] === option.CountryID)" style="font-size: 500;"> 
                    {{ option.CountryName }}
                </option>                                            
            </select>
          </td>
        </ng-container>
        } 
        @else {
          <ng-container matColumnDef={{i}}>
            <th mat-header-cell class="scrollable" *matHeaderCellDef>Maut Kms</th>
            <td class="scrollable" mat-cell *matCellDef="let element; let ind=index">
              <div>
                <input type="number" value={{formatMautData(element[i])}} style="width: 100px;" (change)="onMautVal($event.target,ind,'rate')">
              </div>
            </td>
          </ng-container>
          }
        } 
      </tr>
      <tr mat-header-row *matHeaderRowDef="mountColumn"></tr>
      <tr mat-row *matRowDef="let row; columns: mountColumn;"></tr>

    </table>
  </div> 

</div>